import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../../core/User';
import { Helper } from '../helper';

@Pipe({
  name: 'normalizeQty'
})

// Pipe used to manage quantity.
// Display the value is available, N/A otherwise.
export class NormalizeQtyPipe implements PipeTransform {

  transform(value: string | number | null | undefined, args?: any): string {
    const qty = +value;
    if (value == null || value === '' || isNaN(qty)) {
      return 'N/A';
    }

    if (!User.isFastcoRole) {
      if (args === 'acc') {
        if (qty > 1000) {
          if (User.sessionCulture === 'fr-ca')
            return  '1000'.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + '+';
          else
            return '1000'.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '+';
        }
        else
          return qty.toString();
      }

      if (qty > 100) {
        return '100+';
      }
    }

    if (User.sessionCulture == "fr-ca") {
      return (value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    } else {
      return (value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
}
